import script from "./StepsNav.vue?vue&type=script&setup=true&lang=js"
export * from "./StepsNav.vue?vue&type=script&setup=true&lang=js"

import "./StepsNav.vue?vue&type=style&index=0&id=1196bdb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1196bdb6"]])

export default __exports__